import { useEffect } from "react"

const NOINDEX_CONTENT = "noindex, nofollow"

/** Sets `<meta name="robots" content="noindex, nofollow">` for the current route. */
export function useNoIndexPage() {
  useEffect(() => {
    let meta = document.querySelector('meta[name="robots"]') as HTMLMetaElement | null
    const created = !meta

    if (!meta) {
      meta = document.createElement("meta")
      meta.name = "robots"
      document.head.appendChild(meta)
    }

    const previousContent = meta.content
    meta.content = NOINDEX_CONTENT

    return () => {
      if (!meta) return
      if (created) {
        meta.remove()
        return
      }
      meta.content = previousContent
    }
  }, [])
}
